import { render, staticRenderFns } from "./RichTitle.vue?vue&type=template&id=2aae3cf1&scoped=true&"
import script from "./RichTitle.vue?vue&type=script&lang=js&"
export * from "./RichTitle.vue?vue&type=script&lang=js&"
import style0 from "./RichTitle.vue?vue&type=style&index=0&id=2aae3cf1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae3cf1",
  null
  
)

export default component.exports